import React from 'react';
import '../Spinner/Spinner.css'
const Spinner = () => {
    return (
        <div className='reletive h-screen'>
            <div class="flex items-center justify-center">
                <div className="lds-spinner mt-96 "><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    );
};

export default Spinner;